import React from 'react';
import { connect } from 'react-redux';

import * as PostActions from "Data/posts/PostActions";

import FacebookPostEditor from "./Facebook/FacebookPostEditor";
import TwitterPostEditor from "./Twitter/TwitterPostEditor";

const platformEditorMap = {
    'facebook': FacebookPostEditor,
    'twitter': TwitterPostEditor
};

const PostEditor = (props) => {
    const Editor = platformEditorMap[props.post.integration_type];
    return <Editor {...props} />;
};

const mapStateToProps = (state, ownProps) => ({
    media: state.media // @todo - try to filter the media?
});

const mapDispatchToProps = {
    editPost: PostActions.editPost,
    removeImage: PostActions.removeImage,
    editPostReply: PostActions.editPostReply,
    editPostReplies: PostActions.editPostReplies,
    removePostReply: PostActions.removePostReply,
    removePostReplies: PostActions.removePostReplies,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PostEditor);
